import { post } from "./ApiService";

export const sendFeedback = async feedback => {
    let url = '/account/sendfeedback';
    return await post(url, feedback );
};